import React from 'react';
import { useBooking } from '../context/BookingContext';
import { useLanguage } from '../context/LanguageContext';
import { ChevronRight } from 'lucide-react';

const stepKeys = ['step.1', 'step.2', 'step.3', 'step.5'];

const StepIndicator = () => {
  const { currentStep } = useBooking();
  const { t } = useLanguage();

  return (
    <div className="bg-white border-b">
      <div className="max-w-[1280px] mx-auto px-4">
        <div className="flex items-center gap-1 py-3 overflow-x-auto">
          {stepKeys.map((key, idx) => {
            const num = idx + 1;
            return (
              <React.Fragment key={key}>
                <span
                  className={`text-xs whitespace-nowrap font-medium transition-colors ${
                    num === currentStep
                      ? 'text-[#484c55] font-semibold'
                      : num < currentStep
                      ? 'text-[#c30909]'
                      : 'text-[#484c55]/40'
                  }`}
                >
                  {num}. {t(key)}
                </span>
                {idx < stepKeys.length - 1 && (
                  <ChevronRight size={14} className="text-[#484c55]/30 flex-shrink-0" />
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default StepIndicator;
